export const VERSION_BEARS = [
    "Grizzly",
    "Yogi",
    "Koala",
    "Paddington",
    "Polar",
    "Gummy",
    "Teddy",
    "Care",
    "Spectacled",
    "BooBoo",
    "Fozzie",
    "Smokey",
    "Grylls",
    "Pom",
    "Baloo",
    "Rupert",
    "Banjo",
];
